import * as React from 'react';
const SvgDielines = (props) => (
  <svg viewBox="0 0 122 122" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.75 49.75v22.5H31M47.875 49.75H42.25a5.625 5.625 0 0 0-5.625 5.625v11.25a5.625 5.625 0 0 0 5.625 5.625h5.625a5.625 5.625 0 0 0 5.625-5.625v-11.25a5.625 5.625 0 0 0-5.625-5.625ZM76 51.625a6.397 6.397 0 0 0-4.523-1.875h-4.852A5.623 5.623 0 0 0 61 55.375v11.25a5.623 5.623 0 0 0 5.625 5.625h5.625a5.623 5.623 0 0 0 5.625-5.625v-3.75H72.25M96.625 49.75H91a5.625 5.625 0 0 0-5.625 5.625v11.25A5.625 5.625 0 0 0 91 72.25h5.625a5.625 5.625 0 0 0 5.625-5.625v-11.25a5.625 5.625 0 0 0-5.625-5.625Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 49.75h3.75M8.5 49.75h3.75M109.75 49.75h3.75M117.25 49.75H121M1 72.25h3.75M8.5 72.25h3.75M109.75 72.25h3.75M117.25 72.25H121M61 121v-3.75M61 113.5v-3.75M61 106v-3.75M61 98.5v-3.75M61 91v-3.75M61 83.5v-3.75M61 34.75V31M61 42.25V38.5M61 27.25V23.5M61 19.75V16M61 12.25V8.5M61 4.75V1M77.875 121v-3.75M77.875 113.5v-3.75M77.875 106v-3.75M77.875 98.5v-3.75M77.875 91v-3.75M77.875 83.5v-3.75M77.875 34.75V31M77.875 42.25V38.5M77.875 27.25V23.5M77.875 19.75V16M77.875 12.25V8.5M77.875 4.75V1"
      stroke="#000"
      strokeWidth={4}
      strokeLinejoin="round"
    />
    <path
      d="M104.125 2.875v15h15M104.125 119.125v-15h15M17.875 119.125v-15h-15M17.875 2.875v15h-15"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgDielines;
